import * as XLSX from 'xlsx-js-style'

const formatDate = (value) => {
	if (!value) {
		return '-'
	}

	const date = new Date(value)
	if (Number.isNaN(date.getTime())) {
		return '-'
	}

	return date.toISOString().slice(0, 10)
}

const formatAmount = (value) => {
	const amount = Number(value)
	if (Number.isNaN(amount)) {
		return '0.00'
	}
	return amount.toFixed(2)
}

const formatStatus = (value) => {
	if (!value) {
		return '-'
	}

	const text = String(value).replaceAll('_', ' ')
	return text.charAt(0).toUpperCase() + text.slice(1)
}

const getInvoiceValueByColumnId = (invoice, columnId) => {
	if (!invoice || !columnId) {
		return ''
	}

	switch (columnId) {
		case 'invoice_number':
			return invoice.invoice_number || '-'
		case 'customer':
			return invoice.customer?.display_name || invoice.customer?.legal_name || '-'
		case 'place':
			return invoice.place?.name || '-'
		case 'amount':
			return formatAmount(invoice.total_amount)
		case 'currency':
			return invoice.currency || '-'
		case 'issue_date':
		case 'due_date':
		case 'marked_as_paid_date':
			return formatDate(invoice[columnId])
		case 'status':
			return formatStatus(invoice.status)
		default:
			return ''
	}
}

const getColumnLabel = (column) => {
	const header = typeof column?.header === 'function'
		? column.header({})
		: column?.header

	if (typeof header === 'string' && header.trim()) {
		return header
	}

	return column?.id || ''
}

const applyHeaderStyles = (worksheet, columnCount) => {
  for (let index = 0; index < columnCount; index += 1) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
    if (worksheet[cellAddress]) {
      worksheet[cellAddress].s = {
        font: {
          bold: true,
        },
      };
    }
  }
};

export const generateExcelExport = (columns = [], data = []) => {
	const exportColumns = (Array.isArray(columns) ? columns : [])
		.filter((column) => column?.id && column.id !== 'action')

	if (!exportColumns.length) {
		return
	}

	const rows = (Array.isArray(data) ? data : []).map((invoice) => {
		return exportColumns.reduce((acc, column) => {
			const label = getColumnLabel(column)
			acc[label] = getInvoiceValueByColumnId(invoice, column.id)
			return acc
		}, {})
	})

	const worksheet = XLSX.utils.json_to_sheet(rows)
  applyHeaderStyles(worksheet, exportColumns.length)
	const workbook = XLSX.utils.book_new()

	XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoices')
	XLSX.writeFile(workbook, `invoices-${new Date().toISOString().slice(0, 10)}.xlsx`)
}